import React from 'react';
import { connect } from 'react-redux';
import { bool, func } from 'prop-types';
import { isTriplePackage } from '../../../../../reducers/packages';
import { PACKAGES_TABLE } from '../../../../../utils/pageSections';
import CompareBtn from '../../TabFooter/CompareBtn';

const SubscriptionFooterInfo = ({
    showCompareAnchor = false
}, { scrollToSection }) => {
    const onComparePackagesClick = () => scrollToSection({ sectionKey: PACKAGES_TABLE });

    return (
        showCompareAnchor && (
            <CompareBtn onComparePackagesClick={onComparePackagesClick}/>
        )
    );
};

SubscriptionFooterInfo.propTypes = {
    showCompareAnchor: bool
};

SubscriptionFooterInfo.contextTypes = {
    scrollToSection: func
};

const mapStateToProps = ({ packages }) => ({
    showCompareAnchor: isTriplePackage(packages)
});

export { SubscriptionFooterInfo };
export default connect(mapStateToProps)(SubscriptionFooterInfo);
